import React from 'react';
import classnames from 'classnames';

import * as QualityUpdatePropTypes from 'types/quality-updates';

import QualityUpdatesList from './components/QualityUpdatesList';
import QualityUpdate from './components/QualityUpdate';

export function QualityUpdates(props) {
  const { data } = props;
  const {
    difficultyMessages,
    headlineMessages,
    standardMessages,
    fateMessage,
    actionMessage,
    areaMessage,
  } = data;

  // Have we got messages?
  const hasMessages = [
    difficultyMessages,
    headlineMessages,
    standardMessages,
    fateMessage,
    actionMessage,
    areaMessage,
  ].some(x => x && (!Array.isArray(x) || x.length));

  const WrapperClass = classnames({
    branch: hasMessages,
    'media--quality-updates': true,
  });

  return (
    <div className={WrapperClass}>
      {(difficultyMessages != null && difficultyMessages.length > 0) && (
        <QualityUpdatesList updates={difficultyMessages} />
      )}
      {(fateMessage != null) ? <QualityUpdate data={fateMessage} /> : null}
      {(actionMessage != null) ? <QualityUpdate data={actionMessage} /> : null}
      {(areaMessage != null) ? <QualityUpdate data={areaMessage} /> : null}
      {(headlineMessages != null && headlineMessages.length > 0) && (
        <QualityUpdatesList updates={headlineMessages} />
      )}
      {(standardMessages != null && standardMessages.length > 0) && (
        <QualityUpdatesList updates={standardMessages} />
      )}
    </div>
  );
}

QualityUpdates.displayName = 'QualityUpdates';

QualityUpdates.propTypes = {
  data: QualityUpdatePropTypes.qualityUpdates.isRequired,
};

export default QualityUpdates;
